import React from "react";

export default (props) => {
  return (
    <div>
      {props.has_rand_plat_step_3_emergency_content ? (
        <div
          dangerouslySetInnerHTML={{
            __html: props.has_rand_plat_step_3_emergency_content,
          }}
        />
      ) : (
        <h4 align="center">
          Template not loaded
          <br/>
          <br/>
        </h4>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevo/Texts/EmergencyElectronicText.js